<template>
  <v-container>
    <v-dialog v-model="dialog" persistent scrollable max-width="90%">
      <v-card>
        <v-card-title class="pa-0">
          <v-col class="text-end px-0 py-0">
            <v-btn icon dark @click="close(false)">
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col class="text-center pt-0 pb-3" cols="12">
            <h1>Edição de guia e itens</h1>
            <p class="mb-0">Edição faturamento ({{typeGuia}}) – Guia Reduzida</p>
          </v-col>
          <v-col class="text-right pb-4 pt-0" cols="6">
            <span class="card-title-form-guia">Nº guia prestador: </span>
            <span style="font-size:16px">{{formData.cabecalhoGuia.numeroGuiaPrestador}}</span>
          </v-col>

          <v-col class="text-left pb-4 pt-0" cols="6">
            <span class="card-title-form-guia">Total Geral (R$): </span>
            <span style="font-size:16px">{{formData.valorTotal.valorTotalGeral | formatPrice}}</span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <DlgGuiaForm
            :formData="formData"
            :formatDate="(date) => formatDate(date)"
            :parseDate="(date) => parseDate(date)"
            :typeGuia="typeGuia"
            :camposList="camposList"
            :dominiosList="dominiosList"
            :getListIndex="(nome_dominio) => getListIndex(nome_dominio)"
            :formRules="formRules"
          />
          <v-divider></v-divider>
          <DlgExamesList
            v-if="examesList && examesList.length"
            :list="examesList"
            :valorTotal="valorExames"
            :formatDate="(date) => formatDate(date)"
            :parseDate="(date) => parseDate(date)"
            :selected="(items, type) => selected(items, type)"
            :cleanSelect="cleanSelect"
            :deleteItems="(type) => deleteItems(type)"
            :showopen="() => showOpen()"
            :updateInfo="() => updateInfo()"
            :dominiosList="dominiosList"
            :getListIndex="(nome_dominio) => getListIndex(nome_dominio)"
            :comboItem="() => comboItem()"
            :formRules="formRules"
            :typeGuia="typeGuia"
            :versaoMaior="versaoMaior"
          /> 
          <DlgOutrosList
            v-if="outrosList && outrosList.length"
            :list="outrosList"
            :valorTotal="valorOutros"
            :formatDate="(date) => formatDate(date)"
            :parseDate="(date) => parseDate(date)"
            :selected="(items, type) => selected(items, type)"
            :cleanSelect="cleanSelect"
            :deleteItems="(type) => deleteItems(type)"
            :showopen="() => showOpen()"
            :updateInfo="() => updateInfo()"
            :dominiosList="dominiosList"
            :getListIndex="(nome_dominio) => getListIndex(nome_dominio)"
            :seqItem="seqItem"
            :versaoMaior="versaoMaior"
            :formRules="formRules"
            :typeGuia="typeGuia"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            height="30px"
            small
            color="primary"
            depressed
            outlined
            @click="close(false)"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            color="primary" 
            height="30px" 
            small 
            depressed 
            @click="save(formData)"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const dadosAutorizacaoInit = { 
  dataAutorizacao: null, 
  senha: null, 
  dataValidadeSenha: null, 
  numeroGuiaOperadora: null,
  ausenciaCodValidacao: null,
  codValidacao: null }
import {mapState} from 'vuex'
import moment from "moment"
import DlgGuiaForm from './DlgGuiaForm'
import DlgExamesList from './DlgExamesList'
import DlgOutrosList from './DlgOutrosList'
export default {
  components: {
    DlgGuiaForm,
    DlgExamesList,
    DlgOutrosList
  },
  data() {
    return {
      formData: {
        cabecalhoGuia: {},
        contratadoExecutante: {},
        contratadoSolicitante: {},
        dadosAutorizacao: {},
        dadosBeneficiario: {},
        dadosInternacao: {},
        dadosSaidaInternacao: {},
        profissionalSolicitante: {},
        profissionalExecutante: {},
        numeroGuiaSolicitacaoInternacao: null,
        outrasDespesas: {
          despesa:[]
        },
        procedimentosExecutados: {
          procedimento: []
        },
        valorTotal: {}
      },
      opts: {},
      cleanSelect: [],
      examesList: [],
      selectedExames: [],
      outrosList: [],
      selectedOutros: [],
      valorExames: null,
      valorOutros: null,
      seqItem: [],

      testes: [],

      // Provisório Id json 
      verificationId: null
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
   computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  methods: {
    save(formData) {
        if(this.examesList && this.examesList.length){
          this.formData.procedimentosExecutados.procedimento = this.examesList
          .map(procedimento=>{
            procedimento.quantidadeExecutada = procedimento.quantidadeExecutada.toString()
            procedimento.valorUnitario = Number(procedimento.valorUnitario).toFixed(2).toString()
            procedimento.valorTotal = procedimento.valorTotal.toString()
            return procedimento
          })
        } else {
          delete this.formData.procedimentosExecutados 
        }
        if(this.outrosList && this.outrosList.length){
          this.formData.outrasDespesas.despesa = this.outrosList
          .map(despesa=>{
            despesa.quantidadeExecutada = despesa.quantidadeExecutada.toString()
            despesa.valorUnitario = Number(despesa.valorUnitario).toFixed(2).toString()
            despesa.valorTotal = despesa.valorTotal.toString()
            return despesa
          })
        } else {
          delete this.formData.outrasDespesas 
        }
        this.updateGuia(formData)
    },

    close(bool) {
      if (!bool) {
        let paramModal = {
          type: "error",
          title: "Deseja cancelar as edição desta guia?",
          message: "As alterações nos campos bem como as exclusões de itens e outras despesas serão descartadas.",
          callback: () => {
            this.cleanSelect = []
            this.selectedExames = []
            this.selectedOutros = []
            this.showClose()
          },
          btConfirm: { name: "Sim", show: true, color: "error" },
          btCancel: { name: "Não", show: true }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
      else {
        this.cleanSelect = []
        this.selectedExames = []
        this.selectedOutros = []
        this.showClose()
      }
    },

    selected(items, type) {
      if (type == 'exames')
      this.selectedExames = items
      else
      this.selectedOutros = items
    },

    getList(payload) {
      let obj = {query:[{modulo: 'Faturamento', acao: 'getguia', payload: payload}]}
      this.$store.dispatch("request/doRequest",obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return false;
        }
        let json = JSON.parse(response.guia_json)
        this.guiaForm(json)
        this.examesList = json.procedimentosExecutados && json.procedimentosExecutados.procedimento.map(el =>{ el.dateFormatted = this.formatDate(el.dataExecucao)})? json.procedimentosExecutados.procedimento : []
        this.outrosList = json.outrasDespesas && json.outrasDespesas.despesa? json.outrasDespesas.despesa.map(el => { el.dateFormatted = this.formatDate(el.dataExecucao); return el}): []
        this.outrosValue =  this.outrosList.length ? false : true

        this.itemsList(this.examesList, this.outrosList)
        
      })
    },

    guiaForm(json) {
      this.formData = {...json}
      if(!this.formData.dadosAutorizacao){
      this.formData.dadosAutorizacao = {...dadosAutorizacaoInit}
      } else {
        this.formData.dadosAutorizacao = Object.assign({...dadosAutorizacaoInit}, this.formData.dadosAutorizacao)
      }
      if (json.valorTotal) {
        this.formData.valorTotal = json.valorTotal
      } else {
        this.formData.valorTotal = { valorTotalGeral: 0 }
      }
      // if (json.profissionalSolicitante) {
      //   this.formData.profissionalSolicitante = json.profissionalSolicitante
      // } else {
      //   this.formData.profissionalExecutante = json.profissionalExecutante
      // }
    },

    itemsList() {
      this.openDlg()
      this.updateInfo()
      this.comboItem()
    },

    deleteItems(type) {
      let paramModal = {
        type: "error",
        btConfirm: { name: "Fechar", show: true },
        btCancel: { name: 'Cancelar', show: false },
        textForm: { show: false }
      }
      if(this.selectedExames.length < 1 && type == 'exames' || this.selectedOutros.length < 1 && type == 'outros') {
        paramModal.title = "Selecione ao menos um item para exclusão"
        paramModal.message = "Você pode excluir um item ou vários itens."
      } else if(this.examesList.length - this.selectedExames.length < 1 && this.outrosList.length - this.selectedOutros.length < 1){
         paramModal.title = "Atenção!"
         paramModal.message = "Você não pode excluir todos os itens de uma guia."
      } else {
          paramModal.title = (type == 'exames')?"Excluir Procedimentos e Exames Realizados?" :  "Excluir Outras despesas?"
          paramModal.message = "Ao excluir, este item não estará mais disponível. <br/> Essa alteração não poderá ser desfeita."
          paramModal.callback = () => {
            if(type == 'exames'){
              let ids = this.selectedExames.map(el => el.id)
              this.deleteItem(ids, type)
            } else {
              let ids = this.selectedOutros.map(el => el.id)
              this.deleteItem(ids, type)
            }
          }
          paramModal.btConfirm.name = 'Excluir'
          paramModal.btConfirm.color = 'error'
          paramModal.btCancel.show = true
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },

    deleteItem(ids, type) {
      setTimeout(() => {this.updateInfo()},100)
      if (type == 'exames')
      this.examesList = this.examesList.filter(el => el.id !== ids.find(ids => ids == el.id))
      else
      this.outrosList = this.outrosList.filter(el => el.id !== ids.find(ids => ids == el.id))
    },

    updateGuia(formData) {
      let guia_id = this.opts.guia_id
      let grupo_economico = this.opts.grupo_economico
      let carteira_guia = JSON.stringify(formData)
      let obj = {query:[ {modulo: 'Faturamento', acao: 'updateguia', payload: {
        grupo_economico,
        guia_id,
        guia_json: carteira_guia
      }}]}
      this.$store.dispatch("request/doRequest",obj, {root: true}).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return false
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.close(true)
            this.getGuias()
          },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    updateInfo() {
      this.valorExames = this.examesList.reduce((total, item) => item.valorTotal? total + Number(item.valorTotal) : total, 0)
      this.valorOutros = this.outrosList.reduce((total, item) => item.valorTotal? total + Number(item.valorTotal) : total, 0)
      this.formData.valorTotal.valorTotalGeral = (this.valorExames + this.valorOutros).toFixed(2)
    },
    comboItem() {
      let updateSeqItem = this.examesList.map(el => ({valor: el.sequencialItem, descricao: el.sequencialItem}))
      .filter(el => el.valor != "")
       setTimeout(() => {
        updateSeqItem.unshift({valor: null, descricao: "Selecione"})
        this.seqItem  = updateSeqItem
      },500)
    },
    getListIndex(nome_dominio){
      let index = this.dominiosList.findIndex(el => el.dominio == nome_dominio)
      return  index
    },
  },
  watch: {
    getGuia(opts) {
      this.opts = opts
      this.getList(opts)
    },
  },
  props: {
    dialog: Boolean,
    openDlg: Function,
    getGuia: Object,
    getGuias: Function,
    showClose: Function,
    showOpen: Function,
    formatDate: Function,
    parseDate: Function,
    selectDespesas: Function,
    typeGuia: String,
    camposList: Array,
    dominiosList: Array,
    versaoMaior: Boolean
  },
};
</script>

<style lang="scss">
#data-table-guias {
  .no-box-shadow, .no-box-shadow *{
    box-shadow: 0 0 0 0!important;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
    padding: 0 8px;
    transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  }
  .theme--light.v-data-table.lotesListTable
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:nth-child(2),
  .theme--light.v-data-table.lotesListTable
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:nth-child(2) {
    max-width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .theme--light.v-data-table.columnsDisabled
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:nth-child(5),
  .theme--light.v-data-table.columnsDisabled
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:nth-child(5) {
    display: none;
  }
  .theme--light.v-data-table.columnsDisabled
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:nth-child(6),
  .theme--light.v-data-table.columnsDisabled
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:nth-child(6) {
    display: none;
  }
  .theme--light.v-data-table.lotesListTable .v-icon.v-icon {
    font-size: 16px !important;
  }
  tbody {
    tr {cursor: pointer;}
  }
  .tabela-info {
    text-overflow: ellipsis;
    overflow: hidden;
    height: 15px;
    max-width: 60px;
  }
  label.v-label.theme--light {
    color: #8f2c11;
  }
}
.card-form {
  padding: 0 130px;
}
.card-title-form-guia {
  font-size: 0.90rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
@media (max-width: 769px) {
  .card-form {
    padding: 0;
  }
}
</style>